import { createFileRoute } from "@tanstack/react-router";
import { NotesPage } from "@/features/notes/notes-page";

export const Route = createFileRoute("/app/w/$weddingId/notes")({ component: NotesPage });
